import { Component, Suspense, lazy, useCallback, useEffect, useRef, useState } from "react";
import BodyFlat, { BodyPoster } from "./BodyFlat";

const Body3D = lazy(() => import("./Body3D"));

const can3D = () => {
  if (new URLSearchParams(window.location.search).get("fallback") === "1") return false;
  if (navigator.deviceMemory && navigator.deviceMemory <= 2) return false;
  try {
    const c = document.createElement("canvas");
    return !!(c.getContext("webgl2") || c.getContext("webgl"));
  } catch {
    return false;
  }
};

class Boundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch() {
    this.props.onError();
  }
  render() {
    return this.state.failed ? null : this.props.children;
  }
}

export default function BodyStage({ active, onSelect }) {
  const ref = useRef(null);
  const [near, setNear] = useState(false);
  const [use3d, setUse3d] = useState(can3D);
  const fail = useCallback(() => setUse3d(false), []);

  useEffect(() => {
    const io = new IntersectionObserver(([e]) => e.isIntersecting && (setNear(true), io.disconnect()), { rootMargin: "400px 0px" });
    io.observe(ref.current);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} className="body-stage relative isolate h-[460px] overflow-hidden rounded-[32px] sm:h-[560px]" data-testid="body-stage" data-mode={use3d ? "3d" : "fallback"}>
      {use3d ? (
        near ? (
          <Boundary onError={fail}>
            <Suspense fallback={<div className="absolute inset-0 flex items-center justify-center p-8"><BodyPoster /></div>}>
              <Body3D active={active} onSelect={onSelect} onError={fail} />
            </Suspense>
          </Boundary>
        ) : (
          <div className="absolute inset-0 flex items-center justify-center p-8"><BodyPoster /></div>
        )
      ) : (
        <BodyFlat active={active} onSelect={onSelect} />
      )}
    </div>
  );
}
